import * as Sentry from "@sentry/browser"

Sentry.init({
  dsn: "https://6b4cc62b5c86418cbb13a2c8033b6dd1@o287304.ingest.sentry.io/4504333707247616",
  environment: window.SENTRY_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.5,
})
